export class ProjectReport {
    ProjectID?: number;
    ProjectTitle?: string;
    DocumentObj: any;    
    AgencyName?: string;
    DocumentName?: string;
    CreatedBy?: number;
    CreatedDate?: Date;
}